module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"Refresh content","touDialogConfirmLabel":"Login & Accept Terms","touDialogTitle":"Adobe Experience Cloud Terms of Use","touTextLine1":"Adobe Experience Cloud Terms of Use have been updated.","touTextLine2a":"Please log into","touTextLine2b":"and accept the updated terms before proceeding.","touTextLine3":"After accepting the terms, please click Refresh content."}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/en_us.json
// module id = 914
// module chunks = 0